import React from 'react';
import { Navigate } from 'react-router-dom';
import { SignupForm } from '../components/auth/SignupForm';
import { useAuth } from '../components/auth/AuthProvider';

const Signup = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 to-emerald-50 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-teal-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // Redirect to account if already logged in
  if (user) {
    return <Navigate to="/my-account" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-emerald-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <SignupForm 
        onSuccess={() => window.location.href = '/my-account?new=true'}
        onSwitchToLogin={() => window.location.href = '/login'}
      />
    </div>
  );
};

export default Signup;